import styled, { css } from 'styled-components';
import Section from '@components/section';
import Text from '@components/text';
import { generateScales } from '@helpers/generate-media-queries';
import { defaultTheme } from '@styles/theme.styled';

export const Container = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 4rem;
    max-width: 35rem;
    width: 100%;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      gap: 3rem;
      align-items: flex-start;
      text-align: left;
    }
  `}
`;

export const AppText = styled(Text)`
  ${({ theme }) => css`
    ${generateScales('font-size', theme.fontSize.body.mobile, theme.fontSize.body.desktop, theme)};
  `}
`;

interface SectionProps {
  backgroundColor?: keyof typeof defaultTheme.backgroundColors;
}

export const AppSection = styled(Section)<SectionProps>`
  ${({ theme, backgroundColor }) => css`
    ${backgroundColor === ('dark' || 'primary') &&
    css`
      ${AppText} {
        color: ${theme.colors.white};
      }
    `}
  `}
`;
